import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import Button from '@/components/Button';
import useResponsive from '@/hooks/useResponsive';

import { AddProductStepProps } from './AddProductStepOne';
import DropzoneFile from './DropzoneFile';

const AddProductStepThree = ({
  step,
  setCurrentStep,
  importProducts,
  isPendingImport,
}: AddProductStepProps) => {
  const [file, setFile] = useState<File | null>(null);
  const theme = useTheme();
  const isSmallDrawer = useResponsive('between', 'lg', 'xl');
  const isPhone = useResponsive('down', 'sm');
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          margin: '1rem 0',
          [theme.breakpoints.between('lg', 'xl')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
          [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '1rem',
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ minWidth: '4.4rem' }}>
          Paso <span style={{ color: theme.palette.primary.main }}>3</span>
        </Typography>
        <Divider
          orientation={isSmallDrawer || isPhone ? 'horizontal' : 'vertical'}
          flexItem
          sx={{
            margin: isSmallDrawer || isPhone ? '0' : `0 ${theme.spacing(2)}`,
          }}
        />
        <Box>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.grey[600],
              '&& span': { color: theme.palette.primary.main },
            }}
          >
            <span>Sube aquí el archivo CSV</span>, que completaste con tus productos
            <br />
            <br />
            Recuerda completar todos los campos predefinidos para cada producto nuevo.
          </Typography>
          <Divider sx={{ margin: '1rem 0' }} />
          <DropzoneFile
            type=".csv"
            setFile={setFile}
            // step={step}
            // setCurrentStep={setCurrentStep}
          />
        </Box>
      </Box>
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: { xxs: 'column-reverse', sm: 'row', lg: 'column-reverse', xl: 'row' },
          justifyContent: { xxs: 'center', sm: 'space-between', lg: 'center', xl: 'space-between' },
          width: '100%',
          alignItems: 'center',
          gap: '1rem',
        }}
      >
        <Button variant="outlined" onClick={() => setCurrentStep(step - 1)}>
          Atrás
        </Button>

        <Button disabled={!file || isPendingImport} onClick={() => importProducts?.(file!)}>
          Subir CSV
        </Button>
      </Grid>
    </Box>
  );
};

export default AddProductStepThree;
